export default [
  {
    path: "list",
    component: (resolve) => require(["../views/active/list.vue"], resolve),
  },
  {
    path: "banner",
    component: (resolve) => require(["../views/active/banner.vue"], resolve),
  },
  {
    path: "subject",
    name: "subject",
    component: (resolve) => require(["../views/active/subject.vue"], resolve),
  },
  {
    path: "template",
    component: (resolve) =>
      require(["../views/active/listTemplate.vue"], resolve),
  },
  {
    path: "type",
    component: (resolve) => require(["../views/active/type.vue"], resolve),
  },
  {
    path: "recycle",
    component: (resolve) => require(["../views/active/recycle.vue"], resolve),
  },
  {
    path: "livereport",
    component: (resolve) => require(["../views/active/liveData.vue"], resolve),
  },
  {
    path: "activereport",
    component: (resolve) =>
      require(["../views/active/activeReport.vue"], resolve),
  },
  {
    path: "activecompany",
    component: (resolve) =>
      require(["../views/active/activeCompany.vue"], resolve),
  },
  {
    path: "activeReportForms",
    component: (resolve) =>
      require(["../views/active/activeReportForms.vue"], resolve),
  },
  {
    path: "activeSession",
    component: (resolve) =>
      require(["../views/active/activeSession.vue"], resolve),
  },
  {
    path: "activePeopleNum",
    component: (resolve) =>
      require(["../views/active/activePeopleNum.vue"], resolve),
  },
  {
    path: "livereport/detail/:id",
    component: (resolve) =>
      require(["../views/active/liveDataDetail.vue"], resolve),
  },
  {
    path: "service",
    component: (resolve) =>
      require(["../views/active/addService.vue"], resolve),
  },
];
